let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jEyjc")).then(() => parcelRequire('dxii2'));